
export const LeadBedroomsEnum = [
    {
        key: 1,
        value: 'Any',
    },
    {
        key: 2,
        value: '1',
    },
    {
        key: 3,
        value: '2',
    },
    {
        key: 4,
        value: '3',
    },
    {
        key: 5,
        value: '4',
    },
    {
        key: 6,
        value: '5',
    },
    {
        key: 7,
        value: '6',
    },
    {
        key: 8,
        value: '7',
    },
    {
        key: 9,
        value: '8',
    },
    {
        key: 10,
        value: '9',
    },
    {
        key: 11,
        value: '10',
    },
    {
        key: 12,
        value: '11',
    },
    {
        key: 13,
        value: '12',
    },
    {
        key: 14,
        value: '13',
    },
    {
        key: 15,
        value: '14',
    },
]
